import { useSelector } from 'react-redux';
import { RootState } from '../../app/redux/store';

export const useAuthAndPrivilege = (requiredPrivilege: string) => {
  const { isAuthenticated, privileges } = useSelector(
    (state: RootState) => state.userPrivileges
  );

  const hasRequiredPrivilege = requiredPrivilege
    ? privileges.includes(requiredPrivilege)
    : true;
  // if no privilages is provided, access is granted

  return { isAuthenticated, hasRequiredPrivilege };
};
